import { schema } from 'normalizr';
import { memberSchema } from './memberSchema';

export const eventSchema = new schema.Entity('event');

eventSchema.define({
  pointOfContact: memberSchema,
});
